import { getRouteApi } from '@tanstack/react-router';
import { NumberInput } from 'cpool-components/input/NumberInput';
import { LOAN_REQUEST_COMMANDS } from 'cpool-constants';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormField } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormField';
import { useAclPermissions } from '~/features/leadDetails/hooks/useAclPermissions';
import type { SchemaLivingSituationForm } from '~/features/leadDetails/schemas/living.schema.ts';
import { canExecuteApplicantCommand } from '~/features/leadDetails/utils/aclPermissions';

type PkwProps = {
    antragsteller: 1 | 2;
};

const Pkw: React.FC<PkwProps> = ({ antragsteller }) => {
    const { leadId } = getRouteApi('/_app/leads_/details/$leadId').useParams();
    const { permissions } = useAclPermissions({ loanRequestId: leadId });
    const { t } = useTranslation();
    const { control } = useFormContext<SchemaLivingSituationForm>();

    return (
        <FormField<SchemaLivingSituationForm, number | null>
            control={control}
            name={`antragsteller${antragsteller}.wohnsituation.anzahlPkw`}
        >
            {({ error, onChange, value }) => (
                <NumberInput
                    id={`antragsteller${antragsteller}.wohnsituation.anzahlPkw`}
                    label={t('LIVING_SITUATION_DATA.HAUSHALT.NUMBER_OF_PRIVATE_CARS')}
                    labelClassName="h-8 w-[175px] shrink-0 justify-start"
                    className="w-full"
                    value={value}
                    onChange={onChange}
                    min={0}
                    allowDecimals={false}
                    disabled={
                        !canExecuteApplicantCommand({
                            applicant: antragsteller,
                            commandName: LOAN_REQUEST_COMMANDS.changeCar,
                            permissions,
                        })
                    }
                    error={error}
                />
            )}
        </FormField>
    );
};

export default Pkw;
